import { LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function BookProgress({ value }: Readonly<{ value: number }>) {
  const { t } = useTranslation();

  return (
    <LinearProgress
      variant='determinate'
      value={value}
      color='inherit'
      aria-label={t('readingView.bookProgress.progressBar.aria', {
        percentage: value,
      })}
      sx={{ height: '2px' }}
    />
  );
}
